import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../core/services/helpers.service';
import { ModalNotifyService } from '../../core/services/modal-notify.service';
import { ClassificazioneAdapter } from '../components/pratica/classificazione/classificazione-adapter';
import { Classificazione } from '../models/classificazione';
import { Argomento } from '../models/tipologiche/argomento';
// import { ArgomentoAssociato } from '../models/tipologiche/argomento-associato';
import { Materia } from '../models/tipologiche/materia';
import { Oggetto } from '../models/tipologiche/oggetto';
// import { OggettoAssociato } from '../models/tipologiche/oggetto-associato';
import { BaseForm } from './base-Form';

export abstract class ClassificazionePraticaFormComponent extends BaseForm {

  materieOptions: Materia[] = [];
  oggettiOptions: Oggetto[] = [];
  argomentiOptions: Argomento[] = [];

  idTipoPratica: string;
  request: Classificazione;
  classificazioneForm: FormGroup;
  listaClassificazioni: Classificazione[];
  abstract getClassificazione(): Classificazione;
  abstract getRequest(request: Classificazione, manageCall: {executeCall: boolean, closeModal: boolean});
  abstract canCheckPrimary(): boolean;

  constructor(private helpersService: HelpersService, private campiForm: FormBuilder, private modalNotifyService: ModalNotifyService) {
    super();
  }

  initRequest() {
    if (!this.getClassificazione()) {
      this.request = ClassificazioneAdapter.createClassificazione(new Classificazione());
    } else {
      this.request = ClassificazioneAdapter.createClassificazione(this.getClassificazione());
    }
  }

  inizializzaForm(listaClassificazioni: Classificazione[]) {
    this.listaClassificazioni = listaClassificazioni;
    this.createForm();
  }

  createForm() {
    this.populateSelect();
    this.initRequest();
    this.classificazioneForm = this.campiForm.group({
      materia: [this.request.materia, Validators.required],
      oggetto: [this.request.oggetto, Validators.required],
      argomento: [this.request.argomento],
      isPrincipale: [this.request.isPrincipale],
    });
  }

  populateSelect() {
    if (this.materieOptions.length === 0) {
      this.helpersService.getMateria().subscribe(response => this.materieOptions = response);
    }
    let classificazionePassed: Classificazione = this.getClassificazione();
    if (classificazionePassed && classificazionePassed.materia && classificazionePassed.materia.id) {
      this.helpersService.getOggetti(classificazionePassed.materia.id).subscribe(response => this.oggettiOptions = response);
    }

    if (classificazionePassed && classificazionePassed.materia && classificazionePassed.materia.id && classificazionePassed.oggetto && classificazionePassed.oggetto.id) {
      this.helpersService.getArgomenti(classificazionePassed.materia.id, classificazionePassed.oggetto.id).subscribe(response => this.argomentiOptions = response);
    }
  }

  saveRequest() {
    this.getRequest(this.request, this.verifyRequest());
    if (this.request.isPrincipale === true) {
      this.helpersService.updatePratica(this.idTipoPratica, this.request.materia.descrizione, this.request.oggetto.descrizione);
    }
  }

  setIdTipoPratica(idTipoPratica: string) {
    this.idTipoPratica = idTipoPratica;
  }

  changedMateriaSelected(materia: Materia) {
    this.request.argomento = null;
    this.argomentiOptions = [];
    this.request.oggetto = null;
    this.oggettiOptions = [];
    this.request.materia = null;
    if (materia) {
      for (let materiaElenco of this.materieOptions) {
        if (materiaElenco.id === materia.id) {
          this.request.materia = materiaElenco;
        }
      }
      this.helpersService.getOggetti(materia.id).subscribe(response => this.oggettiOptions = response);
    }
  }

  changedOggettoSelected(oggetto: Oggetto) {
    this.request.argomento = null;
    this.argomentiOptions = [];
    this.request.oggetto = null;
    if (oggetto) {
      for (let oggettoElenco of this.oggettiOptions) {
        if (oggettoElenco.id === oggetto.id) {
          this.request.oggetto = oggettoElenco;
        }
      }
      this.helpersService.getArgomenti(this.request.materia.id, oggetto.id).subscribe(response => this.argomentiOptions = response);
    }
  }

  changedArgomentoSelected(argomento: Argomento) {
    this.request.argomento = null;
    if (argomento) {
      for (let argomentoElenco of this.argomentiOptions) {
        if (argomentoElenco.id === argomento.id) {
          this.request.argomento = argomentoElenco;
        }
      }
    }
  }

  verifyRequest(): {executeCall: boolean, closeModal: boolean} {
    if (this.getClassificazione()) {
      let classificazionePassed = this.getClassificazione();
      if (this.request.materia.id === classificazionePassed.materia.id &&
          this.request.oggetto.id === classificazionePassed.oggetto.id &&
          ((!this.request.argomento && !classificazionePassed.argomento) ||
            (this.request.argomento && classificazionePassed.argomento && this.request.argomento.id === classificazionePassed.argomento.id)
          )) {
        return {executeCall: false, closeModal: true};
      }
    }

    if (!this.listaClassificazioni) {
      return {executeCall: true, closeModal: true};
    }

    let found = false;
    for (let classificazione of this.listaClassificazioni) {
      if (this.request.materia.id === classificazione.materia.id &&
          this.request.oggetto.id === classificazione.oggetto.id &&
          ((!this.request.argomento && !classificazione.argomento) ||
            (this.request.argomento && classificazione.argomento && this.request.argomento.id === classificazione.argomento.id)
          )) {
        this.modalNotifyService.genericErrorMessage('Non si possono inserire due classificazioni uguali');
        found = true;
      }
    }
    if (found) {
      return {executeCall: false, closeModal: false};
    } else {
      return {executeCall: true, closeModal: true};
    }
  }
}
